export const APPFORMS_NAME = 'APPFORMS';
export const COL_NAME_TYPE = 'ETYPE';
export const COL_NAME_SCREEN_NAME = 'ENAME';
export const COL_NAME_KLINE = 'KLINE';
export const COL_NAME_PARENT = 'FATENAMECH';
export const COL_NAME_APP_NAME = 'APPNAME';
export const COL_NAME_APP_LANG = 'LANG';
export const COL_NAME_FORM_TITLE = 'TITLE';
export const COL_NAME_FORM_DESCRIPTION = 'DESCRIPTION';
export const COL_NAME_APP_FIELDS_PREVIEW = 'TABFLAG';
export const COL_NAME_APP_FIELDS_NAME = 'NAME';
export const COL_NAME_APP_FIELDS_TITLE = 'NEWTITLE';
export const APP_SEARCH_CURR_USER = 'CURRENT_USER';
